import { render, staticRenderFns } from "./formbuilderfieldsMention.vue?vue&type=template&id=93c32e3e"
import script from "./formbuilderfieldsMention.vue?vue&type=script&lang=js"
export * from "./formbuilderfieldsMention.vue?vue&type=script&lang=js"
import style0 from "./formbuilderfieldsMention.vue?vue&type=style&index=0&id=93c32e3e&prod&lang=scss"
import style1 from "./formbuilderfieldsMention.vue?vue&type=style&index=1&id=93c32e3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports